import { createFileRoute, notFound } from '@tanstack/react-router';

import { loadDataprevEmployeeMessages } from '@/modules/dataprev-employee/public';
import { lazyScreen } from '@/shared/screen';

// /dev/dataprev (só dev): as quatro telas reais da Dataprev sobre o MSW, sem login (X02).
// Em produção responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/dataprev/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  loader: () => loadDataprevEmployeeMessages(),
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'DataprevDevPage') : () => null,
});
